/*!
 * Legal Disclaimer for App licence
 *
 * Licence to use fonts in native, web, or hybrid apps on mobile or stationary devices, for example personal computers, smart phones, entertainment systems, game consoles, medical instruments, etc.
 *
 * Should the license download limit be exceeded the license holder will be required to contact Lineto.com for an upgrade.
 *
 * It is strictly prohibited to rename the font and to download or use these fonts in any other media.
 *
 * These Web fonts are licensed exclusively for the use on the following App(s):
 *
 * clipboardhealth (Total Downloads: <50k)
 *
 */

/*!
 * Legal Disclaimer for Web licence
 *
 * Licence to use self-hosted webfonts for displaying dynamic text on specified website domains. Our package includes WOFF and WOFF2 font formats.
 *
 * Should the license page views limit be exceeded the license holder will be required to contact Lineto.com for an upgrade.
 *
 * It is strictly prohibited to rename the font and to download or use these fonts in any other media.
 *
 * These Web fonts are licensed exclusively for the use on the following domain(s) and their subdomains:
 *
 * clipboardhealth.com (monthly pageviews: < 250K)
 *
 */

/*! Circular Font - Book (400) and Medium (500) weights */
@font-face {
  font-family: Circular;
  src:
    url("/assets/fonts/CircularXXWeb-Book.woff2") format("woff2"),
    url("/assets/fonts/CircularXXWeb-Book.woff") format("woff");
  font-display: swap;
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: Circular;
  src:
    url("/assets/fonts/CircularXXWeb-Medium.woff2") format("woff2"),
    url("/assets/fonts/CircularXXWeb-Medium.woff") format("woff");
  font-display: swap;
  font-style: normal;
  font-weight: 500;
}

/*! Lato - Rebrand body text */
@font-face {
  font-family: Lato;
  src: url("/assets/fonts/Lato-Light.ttf") format("truetype");
  font-display: swap;
  font-style: normal;
  font-weight: 300;
}

@font-face {
  font-family: Lato;
  src: url("/assets/fonts/Lato-Regular.ttf") format("truetype");
  font-display: swap;
  font-style: normal;
  font-weight: 400;
}

@font-face {
  font-family: Lato;
  src: url("/assets/fonts/Lato-Italic.ttf") format("truetype");
  font-display: swap;
  font-style: italic;
  font-weight: 400;
}

@font-face {
  font-family: Lato;
  src: url("/assets/fonts/Lato-Medium.ttf") format("truetype");
  font-display: swap;
  font-style: normal;
  font-weight: 500;
}

@font-face {
  font-family: Lato;
  src: url("/assets/fonts/Lato-SemiBold.ttf") format("truetype");
  font-display: swap;
  font-style: normal;
  font-weight: 600;
}

@font-face {
  font-family: Lato;
  src: url("/assets/fonts/Lato-Bold.ttf") format("truetype");
  font-display: swap;
  font-style: normal;
  font-weight: 700;
}

/*! Lora - Variable font for rebrand headings */
@font-face {
  font-family: Lora;
  src: url("/assets/fonts/Lora-VariableFont_wght.ttf") format("truetype");
  font-display: swap;
  font-style: normal;
  font-weight: 100 900;
}

@font-face {
  font-family: Lora;
  src: url("/assets/fonts/Lora-Italic-VariableFont_wght.ttf") format("truetype");
  font-display: swap;
  font-style: italic;
  font-weight: 100 900;
}

/* Disable font synthesis to prevent fake bold/light rendering */
* {
  font-synthesis: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-variant: normal;
  font-feature-settings: normal;
}
